import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LogoLoaderModule } from '@y42/core/logo-loader';
import { ChatSingleRoomComponent } from './chat-single-room/chat-single-room.component';
import { ChatRoomModule } from './components/chat-room/chat-room.module';

@NgModule({
  declarations: [ChatSingleRoomComponent],
  imports: [CommonModule, LogoLoaderModule, ChatRoomModule],
  exports: [ChatSingleRoomComponent],
})
export class ChatModule {}
